import CountUp from "react-countup"
import { cn } from "../../utils/classnames"

interface Props {
  score: number
  index?: number
  size?: "sm" | "md"
}

const getScoreTierClasses = (score: number) => {
  if (score >= 80) return "bg-red-500 text-white ring-2 ring-red-200"
  if (score >= 60) return "bg-yellow-400 text-neutral-900"
  if (score >= 40) return "bg-primary-400 text-white"
  return "bg-neutral-300 text-neutral-700"
}

const ScoreCircle = ({ score, index = 0, size = "md" }: Props) => {
  const sizeClasses =
    size === "sm"
      ? "w-10 h-10 text-sm font-semibold"
      : "w-14 h-14 text-xl font-bold"

  return (
    <div
      className={cn(
        "rounded-full flex items-center justify-center shrink-0",
        sizeClasses,
        getScoreTierClasses(score)
      )}
    >
      <CountUp end={score} duration={0.8} delay={index * 0.1} />
    </div>
  )
}

export default ScoreCircle
